module.exports = __webpack_public_path__ + "static/loving-every-child-33b821dc4c68dce8cd94ecab23688121.jpg";